/**
 * Utility functions for handling exit behavior in rent-reporting-web
 * Detects mobile apps via query parameters: fromApp=iphone|android|ipad
 */

type MobileAppSource = 'iphone' | 'android' | 'ipad';

/**
 * Checks if the user came from a mobile app based on query parameters
 */
export function isFromMobileApp(queryParams: Record<string, string | Array<string> | undefined>): boolean {
  const fromApp = queryParams.fromApp;

  if (typeof fromApp !== 'string') {
    return false;
  }

  const mobileAppSources: Array<MobileAppSource> = ['iphone', 'android', 'ipad'];
  return mobileAppSources.includes(fromApp as MobileAppSource);
}

/**
 * Handles exit navigation - either browser back or redirect to your rental page
 */
export function handleExitNavigation(queryParams: Record<string, string | Array<string> | undefined>): void {
  if (isFromMobileApp(queryParams)) {
    // Use browser back for mobile app users
    window.history.back();
  } else {
    // Redirect to your rental page for web users
    window.location.href = '/renting/your-rental';
  }
}
